import { Button, Dropdown, DropdownMenu, DropdownMenuItem, QuestionmarkCircleIcon } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthClaims } from '../../hooks/useAuthClaims';
import { AboutModal } from '../AboutModal/AboutModal';

type HelpMenuProps = {
  /** Mit Label als Text-Button (z. B. im Mobile-Menü), sonst nur Icon */
  label?: string;
  className?: string;
};

export const HelpMenu = ({ label, className }: HelpMenuProps) => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const [showAboutModal, setShowAboutModal] = useState<boolean>(false);

  const openExternal = (url: string) => window.open(url, '_blank');

  const aboutMenuEntries: DropdownMenuItem[] = [
    { label: t('about.whatIsNew'), onClick: () => openExternal('https://r.tks.eu/changelog') },
    { label: t('about.handbooks'), onClick: () => openExternal('https://r.tks.eu/planung-doku') },
    { label: t('about.bookTraining'), onClick: () => openExternal('https://tk-schulsoftware.de/termine/schulung') },
    { label: t('about.contact'), onClick: () => setShowAboutModal(true) },
  ];

  return (
    <>
      <Dropdown
        trigger={
          <Button className={className} hierarchy='tertiary' icon={<QuestionmarkCircleIcon />}>
            {label}
          </Button>
        }
      >
        <DropdownMenu data={aboutMenuEntries} />
      </Dropdown>
      <AboutModal
        state={showAboutModal}
        setState={(value) => setShowAboutModal(value)}
        organizationUuid={pimAuthClaims.getOrganizationUuid()}
      />
    </>
  );
};
